import { updateObject } from "../../util/updateObject";
import * as actionTypes from "./actionTypes";
import {
  createMessagiVocaliDataInitialState,
  currentMessagiVocali,
} from "./helper";

const initialState = {
  messaggiVocaliData: {
    data: [],
    lastUpdated: "",
    loading: false,
  },
  currentMessaggiVocale: currentMessagiVocali,
  createMessagiVocaliData: createMessagiVocaliDataInitialState,
  createMessagiVocaliLoading: false,
  exportLoading: false,
};

const setMessaggiVocaliData = (state, action) => {
  return updateObject(state, {
    messaggiVocaliData: updateObject(state.messaggiVocaliData, {
      [action.key]: action.value,
    }),
  });
};

const setCurrentMessaggiVocale = (state, action) => {
  return updateObject(state, {
    currentMessaggiVocale: updateObject(state.currentMessaggiVocale, {
      [action.key]: action.value,
    }),
  });
};

const setMessaggiVocaliCreateDropdowns = (state, action) => {
  return updateObject(state, {
    createMessagiVocaliData: updateObject(state.createMessagiVocaliData, {
      [action.key]: action.value,
    }),
  });
};

const setCreateUpdateDeleteMessaggiVocaliLoading = (state, action) => {
  return updateObject(state, {
    createMessagiVocaliLoading: action.value,
  });
};

const setMessaggiVocaliExportLoading = (state, action) => {
  return updateObject(state, {
    exportLoading: action.value,
  });
};

const messaggiVocaliReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_MESSAGGI_VOCALI_DATA:
      return setMessaggiVocaliData(state, action);
    case actionTypes.GET_CURRENT_MESSAGGI_VOCALE:
      return setCurrentMessaggiVocale(state, action);
    case actionTypes.GET_MESSAGI_VOCALI_CREATE_DROPDOWNS:
      return setMessaggiVocaliCreateDropdowns(state, action);
    case actionTypes.CREATE_UPDATE_DELETE_MESSAGGI_VOCALI:
      return setCreateUpdateDeleteMessaggiVocaliLoading(state, action);
    case actionTypes.EXPORT_MESSAGGI_VOCALI_LOADING:
      return setMessaggiVocaliExportLoading(state, action);
    default:
      return state;
  }
};

export default messaggiVocaliReducer;
